import React, { useRef } from "react";
import { useTranslation } from "react-i18next"; // For localization
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
  Paper,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // MUI icon
import leaseBusinessDiagram from "images/business/lease-business.png";
import ContactMailIcon from "@mui/icons-material/ContactMail"; // MUI icon for header
import BgTitle from "components/title/BgTitle";

const LeaseBusinessMobile = ({ isXs = false }) => {
  const myRef = useRef();
  const { t } = useTranslation(); // Initialize translation hook
  const theme = useTheme();

  return (
    <Box
      ref={myRef}
      id="lease-business"
      sx={{
        borderRadius: 2, // Rounded corners
        textAlign: "left", // Left-align text
        mt: 4,
      }}
    >
      {/* Heading */}
      <BgTitle text={t("business.lease-of-pc.heading")} isCenter={true} />

      {/* Image */}
      <Box
        sx={{
          textAlign: "center", // Center-align image
          mt: 1,
        }}
      >
        <Box
          component="img"
          src={leaseBusinessDiagram}
          alt="Lease Business Diagram"
          sx={{
            width: "100%",
            maxWidth: "300px", // Limit image size
            borderRadius: 2, // Rounded corners
            boxShadow: 3, // Add shadow
            margin: "auto", // Center image
          }}
        />
      </Box>

      {/* Description */}
      <Box
        sx={{
          textAlign: "left",
          borderLeft: 2,
          borderColor: "primary.main",
          padding: 1,
          mt: 2,
          bgcolor: "#f5f5f5",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.text.secondary, // Use secondary text color
            mb: 1,
            fontSize: "0.8rem",
          }}
        >
          {t("business.lease-of-pc.description")}
        </Typography>
      </Box>

      {/* Feature List */}
      <List>
        {t("business.lease-of-pc.content", { returnObjects: true }).map(
          (feature, index) => (
            <ListItem
              key={index}
              sx={{ padding: 0, marginBottom: theme.spacing(1) }}
            >
              <ListItemIcon sx={{ minWidth: "32px" }}>
                <CheckCircleIcon sx={{ color: theme.palette.primary.main }} />
              </ListItemIcon>
              <ListItemText
                primary={feature}
                primaryTypographyProps={{
                  variant: "body2",
                  color: "text.secondary",
                }}
              />
            </ListItem>
          )
        )}
      </List>

      {/* Contact Section */}
      <Box
        component={Paper}
        variant="outlined"
        sx={{
          marginTop: theme.spacing(2),
          backgroundColor: "#ffffff", // White background
          borderRadius: 2, // Rounded corners
          overflow: "hidden", // Ensure border radius applies to children
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            padding: theme.spacing(2),
            backgroundColor: "#f5f5f5",
          }}
        >
          <ContactMailIcon sx={{ marginRight: theme.spacing(1) }} />{" "}
          {/* Icon */}
          <Typography variant="h6" component="h3" sx={{ fontWeight: "bold" }}>
            Contact
          </Typography>
        </Box>

        {/* Body */}
        <Box
          sx={{
            padding: theme.spacing(2),
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.primary,
            }}
          >
            {t("business.lease-of-pc.contact")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default LeaseBusinessMobile;
